/* eslint-disable */

import { FC, Suspense, useState } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import { AffiliatePermissionsEnum } from 'enums/accessTemplates';

import { SwitchRouter } from 'pages/utils';
import useScreen from 'hooks/useScreen';
import useAuth from 'store/auth';
import useBranding from 'store/branding';
import useCurrencies from 'store/currencies';
import usePartners from 'store/partner';
import useConfiguration from 'store/configuration';
import useMount from 'hooks/useMount';
import HeaderNavigation from 'components/sections/HeaderNavigation';
import SidebarNavigation from 'components/sections/SidebarNavigation';
import ProjectLoading from 'components/sections/ProjectLoading';
import Preloader from 'components/sections/Preloader';
import FooterNavigation from 'components/sections/FooterNavigation';
import useNativeNotifications from 'utils/messaging/notifications/useNativeNotification';

import routes from './routes';

const sx = (theme: Theme) => ({
  content: {
    [theme.breakpoints.down('md')]: {
      pl: '0px',
    },
    [theme.breakpoints.up('md')]: {
      pl: '300px',
    },
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 65px)',
  },
});

const App: FC = () => {
  const theme = useTheme();
  const { isMobile } = useScreen();
  const [open, setOpen] = useState(!isMobile);
  const [authState] = useAuth();
  const [brandingState] = useBranding();
  const [, currencyActions] = useCurrencies();
  const [, partnerActions] = usePartners();
  const [, configurationActions] = useConfiguration();
  const { enableNotifications } = useNativeNotifications();

  useMount(() => {
    currencyActions.getAll();
    currencyActions.getPlayerCurrencies();
    partnerActions.get();
    configurationActions.getPublic();

    enableNotifications();
  });

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  return (
    <Preloader>
      <Box minHeight="100vh">
        <SidebarNavigation
          open={isMobile ? open : true}
          setOpen={setOpen}
          existPermission={authState.data?.affiliate?.permission as AffiliatePermissionsEnum}
          logoPath={brandingState?.settings?.logo || ''}
        />
        <Box sx={sx(theme).content}>
          <HeaderNavigation setSidebarOpen={handleDrawerOpen} />
          <Box
            width="100%"
            height="100%"
            flexGrow={1}
            sx={{
              [theme.breakpoints.down('sm')]: {
                paddingTop: '65px',
                paddingBottom: '65px',
              },
            }}
          >
            <Suspense fallback={<ProjectLoading isFixed={false} />}>
              <SwitchRouter
                routes={routes}
                existPermission={authState?.data?.affiliate?.permission as AffiliatePermissionsEnum}
              />
            </Suspense>
          </Box>
          <FooterNavigation existPermission={authState.data?.affiliate?.permission as AffiliatePermissionsEnum} />
        </Box>
      </Box>
    </Preloader>
  );
};

export default App;
